import { NgModule } from '@angular/core';
import { CounterComponent } from './counter.component';
import { SharedModule } from '../../shared.module';
import { CommonModule, DecimalPipe } from '@angular/common';

@NgModule({
    imports: [CommonModule, SharedModule],
    declarations: [CounterComponent],
    providers: [DecimalPipe],
    exports: [CounterComponent],
})
export class CounterModule {}
